// =============================================================================
// Dashboard Main — entry point for esbuild bundle
// Wires all modules together and initializes the dashboard
// =============================================================================

import { init, initNavigation, registerView, renderView } from './dashboard-auth';
import { renderProfile, renderHelp, renderWeChat, renderCredits, setShowCreditsHistory, setShowAddressModal } from './dashboard-views';
import { renderMyWorks, downloadPDF, loadAlbumCSS, initPreviewListeners, showCreditsHistory } from './dashboard-works';
import { renderMyOrders, openUnifiedOrderModal, showAddressModal } from './dashboard-orders';
import { syncAddressesFromServer } from './dashboard-data';

// Register view renderers with the auth module's view router
registerView('works', renderMyWorks);
registerView('orders', renderMyOrders);
registerView('credits', renderCredits);
registerView('profile', renderProfile);
registerView('help', renderHelp);
registerView('wechat', renderWeChat);

// Wire up cross-module function references that views module needs
setShowAddressModal(showAddressModal);
setShowCreditsHistory(showCreditsHistory);

// Listen for PDF download events dispatched from the orders module
document.addEventListener('dashboard:download-pdf', function (e: Event) {
  const detail = (e as CustomEvent).detail;
  downloadPDF(detail.albumId, detail.albumTitle, detail.btn, detail.orderId, detail.publishedTemplateId);
});

// Initialize: check auth, set up navigation, bind preview modal listeners
init();
initNavigation();
initPreviewListeners();

// Sync addresses from server (migrates legacy localStorage addresses on first run)
syncAddressesFromServer().then(function() {
  // If currently viewing profile, re-render with fresh server data
  const activeView = document.querySelector('.menu-item.active');
  if (activeView && (activeView as HTMLElement).getAttribute('data-view') === 'profile') {
    renderView('profile');
  }
}).catch(function(e) { console.warn('Address sync failed:', e); });

// Render default view and preload template CSS (matches original inline script)
renderView('works');
loadAlbumCSS();

// Auto-open order modal if URL contains ?orderAlbum=<id> (e.g. from template page)
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('orderAlbum')) {
  const orderAlbumId = urlParams.get('orderAlbum')!;
  setTimeout(function () { openUnifiedOrderModal(orderAlbumId); }, 300);
  if (window.history.replaceState) {
    window.history.replaceState({}, '', 'dashboard.html');
  }
}
